import { useRef } from 'react';
import JoditEditor from 'jodit-react';

const TextEditor = (props) => {
    
    const {content, setContent} = props
    const editor = useRef(null);
    
    const config = {
        readonly: false,
        height: 500,
        width: '100%',
        placeholder: 'Start typing...',
        toolbarSticky: false,
        style: { fontSize: '18px', width: '100%' },
        buttons: [
            'source', 'bold', 'italic', 'underline', 'strikethrough', 'ul', 'ol',
            'font', 'fontsize', 'paragraph', 'table', 'link', 'unlink',
            'align', 'cut', 'copy', 'paste', 'undo', 'redo', 'hr'
        ]
    }

    return (
        <div style={{ width: '100%' }}>
            <JoditEditor
                ref={editor}
                value={content}
                config={config}
                tabIndex={1} // tabIndex of textarea
                onBlur={newContent => {
                    setContent(newContent);           // update parent
                }}
            />
        </div>
    );
};

export default TextEditor;